import { ECountry } from 'common/const';

/* Страна, которую показывает страница (US-034, R-3). ME — только явное 'ME' из ответа;
 *  ответ старого API без country и любое неизвестное значение — RS, сегодняшняя страница
 *  (критерий 4 US-034, безопасный дефолт US-023). */
export const getOrganizationCountry = (organization?: { country?: ECountry } | null): ECountry =>
  organization?.country === ECountry.ME ? ECountry.ME : ECountry.RS;

/* Страна с устройства (localStorage): мусор и отсутствие — null, вызывающий берёт RS. */
export const parseStoredCountry = (raw: string | null): ECountry | null =>
  raw === ECountry.ME || raw === ECountry.RS ? raw : null;
